import { TENANCY_ENABLED } from './tenant';

export const LEGACY_BRANDING = {
  NameMarathi: 'वसंतराव नाईक विमुक्त जाती व भटक्या जमाती विकास महामंडळ (मर्यादित)',
  NameEnglish: 'Vasantrao Naik Vimukta Jaties and Nomedic Tribes Development Corporation (LTD.)',
  LogoUrl: require('@/assets/images/header4.png'),
  WebsiteUrl: 'https://www.vnvjntdc.org',
  AddressMarathi: 'जुहू सुप्रिम शॉपिंग सेंटर, गुलमोहर क्रॉस रोड नं.९, विलेपार्ले (पश्चिम), मुंबई- ४०० ०४९.',
  Phone: '०२२ - २६२०२५८६.',
  Email: 'vnvjntdcproject@gmail.com',
  Cin: 'CIN-U65990MH1984SGC032054'
};

export default {
  computed: {
    tenantMode() {
      return TENANCY_ENABLED;
    },
    portalBranding() {
      return TENANCY_ENABLED ? this.$store.state.tenant : LEGACY_BRANDING;
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/portalBranding.js